/* eslint-disable */
import Knoten from './Knoten'
import Stab from './Stab'
import Auflager from './Auflager'
import Material from './Material'
import Gelenk from './Gelenk'
import Querschnitt from './Querschnitt'
import Lastfall from './Lastfall'
// import {berechnen} from './berechnung'

export default class SatikSystem {
    constructor(){
        this.Knotenliste = []
        this.Stabliste = []
        this.Gelenkliste = []
        this.Materialliste = []
        this.Querschnittliste = []
        this.Auflagerliste = []
        this.Lastfallliste = []
        this.Maßlinienliste =[]
        this.Bbox = {
            left: -10000,
            right: 10000,
            top: 10000,
            bottom: -10000,
            get ['width'](){return this.right - this.left},
            get ['height'](){return this.top - this.bottom}
        }
    }

    setSize(){
        return new Promise((resolve, reject)=>{
            if (!this.Knotenliste) reject(new Error('Knotenliste nicht vorhanden.'))
            if (this.Knotenliste.length > 1) {
                this.Bbox.left = this.Knotenliste[0].x
                this.Bbox.top = this.Knotenliste[0].y
                this.Bbox.right = this.Bbox.left
                this.Bbox.bottom = this.Bbox.top
                this.Knotenliste.forEach(knoten =>{
                    switch(true){
                        case (knoten.x < this.Bbox.left):
                        this.Bbox.left = knoten.x
                        break
                        case (knoten.x > this.Bbox.right):
                        this.Bbox.right = knoten.x
                    }
                    switch(true){
                        case (knoten.y < this.Bbox.bottom):
                        this.Bbox.bottom = knoten.y
                        break
                        case (knoten.y > this.Bbox.top):
                        this.Bbox.top = knoten.y
                        break
                    }
                })
                resolve(this.Bbox)
            }
            else {
                reject(new Error('Es müssen mindestens 2 Knoten eingegeben werden um diese zeichnen zu können.'))         
            }
        })
    }

// '----Auflager
    /**
     * Erstellt ein neues Auflager
     * @param cX Federsteifigkeit in X-Richtung. -1 = starr
     * @param cY Federsteifigkeit in Y-Richtung. -1 = starr
     * @param cM Drehfedersteifigkeit. -1 = starr
     * @param Winkel_degrees Winkel für gedrehte Auflager.
     */
    newAuflager(cX, cY, cM, Winkel_degrees){
        const cAuflager = new Auflager(null, cX, cY, cM, Winkel_degrees)
        this.addAuflager(cAuflager)
        return cAuflager
    }

    addAuflager(auflager){
        auflager.list = this.Auflagerliste
        this.Auflagerliste.push(auflager)
        console.log('Auflager Nr.' + auflager.number + ' wurde hinzugefügt.')        
    }

    editAuflager(auflager, cX, cY, cM, Winkel_degrees){
        auflager.Werte = [cX, cY, cM]
        auflager.Winkel_Degree = Winkel_degrees
        console.log(auflager.name +' wurde geändert.')
    }

    deleteAuflager(auflager){
        if (this.Auflagerliste.indexOf(auflager)==-1) return console.log('Auflager nicht in Liste')
        auflager.Knotenliste.forEach(knoten =>{
            knoten.Auflager = null
        })
        this.Auflagerliste.splice(this.Auflagerliste.indexOf(auflager),1)
        console.log('Auflager wurde gelöscht.')
    }

    deleteAuflager_byNumber(number){
        if (number > this.Auflagerliste.length) {
            console.log('Fehler beim Löschen. Auflager nicht gefunden.')
        }else {
            const cAuflager = this.Auflagerliste[number -1]
            this.deleteAuflager(cAuflager)
        }
    }

// '----Knoten
    newKnoten(x,y,auflager){
        const cKnoten = new Knoten(null,x,y,auflager)
        this.addKnoten(cKnoten)
        return cKnoten
    }

    addKnoten(knoten){
        knoten.list = this.Knotenliste
        this.Knotenliste.push(knoten)
        if (knoten.Auflager){knoten.Auflager.add_Knotenverknüpfung(knoten)}
        console.log('Knoten Nr.' + knoten.number + ' wurde hinzugefügt.')
    }

    editKnoten(knoten,x,y,Auflager){
    knoten.x = x
    knoten.y = y
    if (knoten.Auflager) {
        knoten.Auflager.delete_Knotenverknüpfung(knoten) 
        knoten.Auflager = null
        }
    if (Auflager){
        knoten.Auflager = Auflager
        knoten.Auflager.add_Knotenverknüpfung(knoten)
        }
    }

    deleteKnoten(knoten){
        //Prüfen ob der Knoten in der Knotenliste existiert
        if (this.Knotenliste.indexOf(knoten)==-1) return console.log('Knoten nicht in Liste')
        // Es müssen alle Verknüpfungen zu dem Knoten gelöscht werden.
        // -Auflagerverknüpfungen, Stäbe die den Knoten nutzen werden gelöscht, Knotenlasten die auf diesen Knoten wirken werden geändert.

        // Release Bindings geht hier nur für die Auflager, da die Stabliste vom ParentObject aus gelöscht werden muss 
        // und auch die Knotenlasten müssen über das ParentObject angesteuert werden.
        knoten.release_bindings()
        
        // Stäbe die den Knoten nutzen löschen.
        // Ganz Wichtig. Stäbe in umgedrehter Reihenfolge löschen, da nach jedem Löschen die übrigen Stäbe in der Stabliste aufrücken.
        let StabCount = knoten.Stabliste.length
        if (StabCount > 0){
            while (StabCount--) {
                const stab = knoten.Stabliste[StabCount]
                this.deleteStab(stab)
            }
        }

        // Knotenlasten die auf den Knoten wirken anpassen.
        this.Lastfallliste.forEach(curLastfall =>{
            curLastfall.Knotenlastliste.forEach(curKnotenlast =>{
                curKnotenlast.delete_Knotenverknüpfung(knoten)
            })
        })
        // '-Knoten aus Maßlinien löschen
        // If Not mMa�linien.count = 0 Then
        //     For Each var1 In mMa�linien.ToArray
        //         Set cMa�linie = var1
        //         For Each var2 In cMa�linie.Knotenliste.ToArray
        //             Set cMa�_Knoten = var2
        //             If cMa�_Knoten Is knoten Then
        //                 cMa�linie.delete_Knoten knoten
        //                 If cMa�linie.Knotenliste.count < 2 Then delete_Ma�linie_byHandle cMa�linie
        //             End If
        //         Next var2
        //     Next var1
        // End If

        // Knoten löschen.
        this.Knotenliste.splice(this.Knotenliste.indexOf(knoten),1)
        console.log('Knoten wurde gelöscht.')
    }

    deleteKnoten_byNumber(number){
        if (number > this.Knotenliste.length) {
            console.log('Fehler beim Löschen. Knoten nicht gefunden.')
        }else {
            const cKnoten = this.Knotenliste[number -1]
            this.deleteKnoten(cKnoten)
        }
    }

// '----Materialien
    newMaterial(Emodul, Wichte, Name){
        const cMaterial = new Material(null, Emodul, Wichte, Name)
        this.addMaterial(cMaterial)
        return cMaterial
    }

    addMaterial(material) {
        material.list = this.Materialliste
        this.Materialliste.push(material)
        console.log('Material Nr.' + material.number + '('+ material.name +') wurde hinzugefügt.')        
    }

    editMaterial(material, emodul, wichte, name){
        material.Emodul = emodul
        material.Wichte = wichte
        material.Name = name
        console.log('Material Nr.' + material.number + '('+ material.name +') wurde geändert.')  
    }

    deleteMaterial(material){
        if (this.Materialliste.indexOf(material)==-1) return console.log('Material nicht in Liste')
        if (material.Querschnittliste.length > 0) return console.log('Material kann nicht gelöscht werden. Es wird noch von Querschnitten verwendet.')
        this.Materialliste.splice(this.Materialliste.indexOf(material),1)
        console.log('Material wurde gelöscht.')
    }

    deleteMaterial_byNumber(number){

    }

// '----Querschnitte
    newQuerschnitt(fläche, trägheitsmoment, material, name){
        const cQuerschnitt = new Querschnitt(null, fläche, trägheitsmoment, material, name)
        this.addQuerschnitt(cQuerschnitt)
        return cQuerschnitt
    }

    addQuerschnitt(querschnitt){
        querschnitt.list = this.Querschnittliste
        querschnitt.Material.add_Querschnittverknüpfung(querschnitt)
        this.Querschnittliste.push(querschnitt)
        console.log('Querschnitt Nr.' + querschnitt.number + ' wurde hinzugefügt.')
    }

    editQuerschnitt(querschnitt, fläche, trägheitsmoment, material, name){
        querschnitt.Fläche = fläche
        querschnitt.Trägheitsmoment = trägheitsmoment
        querschnitt._name = name
        querschnitt.Material.delete_Querschnittverknüpfung(querschnitt)
        querschnitt.Material = material
        querschnitt.Material.add_Querschnittverknüpfung(querschnitt)
        console.log('Querschnitt Nr.' + querschnitt.number + ' wurde geändert.')
    }

    deleteQuerschnitt(querschnitt){
        if (this.Querschnittliste.indexOf(querschnitt)==-1) return console.log('Querschnitt nicht in Liste')
        if (querschnitt.Stabliste.length > 0) return console.log('Querschnitt kann nicht gelöscht werden. Er wird noch von Stäben verwendet.')
        querschnitt.release_bindings()
        this.Querschnittliste.splice(this.Querschnittliste.indexOf(querschnitt),1)
        console.log('Querschnitt wurde gelöscht.')
    }

    deleteQuerschnitt_byNumber(number){

    }

// '----Gelenke
    newGelenk(cN, cQ, cM){
        const cGelenk = new Gelenk(null, cN, cQ, cM)
        this.addGelenk(cGelenk)
        return cGelenk
    }

    addGelenk(gelenk){
        gelenk.list = this.Gelenkliste
        this.Gelenkliste.push(gelenk)
        console.log('Gelenk Nr.' + gelenk.number + '('+ gelenk.Name +') wurde hinzugefügt.')   
    }

    editGelenk(gelenk, cN, cQ, cM){
        gelenk.Werte = [cN, cQ, cM]
        console.log(auflager.name +' wurde geändert.')
    }

    deleteGelenk(gelenk) {
        if (this.Gelenkliste.indexOf(gelenk)==-1) return console.log('Gelenk nicht in Liste')
        gelenk.Stabliste.forEach(stab =>{
            if(stab.StartGelenk === gelenk) stab.StartGelenk = null
            if(stab.EndGelenk === gelenk) stab.EndGelenk = null
        })
        this.Gelenkliste.splice(this.Gelenkliste.indexOf(gelenk),1)
        console.log('Gelenk wurde gelöscht.')
    }

    deleteGelenk_byNumber(number){
        if (number > this.Gelenkliste.length) {
            console.log('Fehler beim Löschen. Gelenk nicht gefunden.')
        }else {
            const cGelenk = this.Gelenkliste[number -1]
            this.deleteGelenk(cGelenk)
        }
    }

// '----Stäbe
    newStab(StartKnoten, EndKnoten, Querschnitt, StartGelenk, EndGelenk, isFachwerkstab, Stabteilungen){
        // GELENKE EINARBEITEN
        const cStab = new Stab(null, StartKnoten, EndKnoten, Querschnitt, StartGelenk, EndGelenk, isFachwerkstab, Stabteilungen)
        this.addStab(cStab)
        return cStab
    }

    addStab(stab){
        stab.list = this.Stabliste
        stab.StartKnoten.add_Stabverknüpfung(stab)
        stab.EndKnoten.add_Stabverknüpfung(stab)
        stab.Querschnitt.add_Stabverknüpfung(stab)
        if (stab.StartGelenk) stab.StartGelenk.add_Stabverknüpfung(stab)
        if (stab.EndGelenk) stab.EndGelenk.add_Stabverknüpfung(stab)
        this.Stabliste.push(stab)
        console.log('Stab Nr.' + stab.number + ' wurde hinzugefügt.')
    } 

    editStab(stab, knoten1, knoten2, querschnitt, isFachwerkstab, gelenk1, gelenk2, Stabteilungen){
        stab.release_bindings()
        stab.StartKnoten = knoten1
        stab.EndKnoten = knoten2
        stab.Querschnitt = querschnitt 
        stab.isFachwerkstab = isFachwerkstab
        stab.StartGelenk = gelenk1 || null
        stab.EndGelenk = gelenk2 || null 
        stab.StartKnoten.add_Stabverknüpfung(stab)
        stab.EndKnoten.add_Stabverknüpfung(stab)
        stab.Querschnitt.add_Stabverknüpfung(stab)
        stab.Stabteilungen = Stabteilungen
        if (stab.StartGelenk) stab.StartGelenk.add_Stabverknüpfung(stab)
        if (stab.EndGelenk) stab.EndGelenk.add_Stabverknüpfung(stab)
    }

    deleteStab(stab){
        if (this.Stabliste.indexOf(stab)==-1) return console.log('Stab nicht in Liste')
        stab.release_bindings(this.Lastfallliste)

        // Stablasten die auf den Stab wirken anpassen.
        this.Lastfallliste.forEach(curLastfall =>{
            curLastfall.Stablastliste.forEach(curStablast =>{
                curStablast.delete_Stabverknüpfung(stab)
            })
        })
        this.Stabliste.splice(this.Stabliste.indexOf(stab),1)
        console.log('Stab wurde gelöscht.')
    }

    deleteStab_byNumber(number){
        if (number > this.Stabliste.length) {
            console.log('Fehler beim Löschen.Stab nicht gefunden.')
        }else {
            const cStab = this.Stabliste[number -1]
            this.deleteStab(cStab)
        }
    }

// '----Lastfälle
    newLastfall(name, color){
        const cLastfall = new Lastfall(null, name, color)
        this.addLastfall(cLastfall)
        return cLastfall
    }

    addLastfall(lastfall){
        lastfall.list = this.Lastfallliste
        this.Lastfallliste.push(lastfall)
        console.log('Lastfall Nr.' + lastfall.number + '('+ lastfall.name +') wurde hinzugefügt.')  
    }

    editLastfall(lastfall, name, color){
        lastfall.name = name
        lastfall.Color = color
    }

    deleteLastfall(lastfall){

    }

    deleteLastfall_byNumber(number){

    }
}

// '----Ma�linien
    // Public Function new_Ma�linie(ByVal Typ As Integer, knoten() As Integer, ByRef Position As RB_Punkt_2D) As clsMa�linie
    // Set new_Ma�linie = New clsMa�linie
    // Dim i As Integer
    // Dim Knoten1 As clsKnoten, Knoten2 As clsKnoten
    // Set Knoten1 = mSys.knoten(knoten(0))
    // Set Knoten2 = mSys.knoten(knoten(1))
    // new_Ma�linie.init Knoten1, Knoten2, Typ, Position
    // For i = 2 To UBound(knoten)
    // new_Ma�linie.add_Knoten mSys.knoten(knoten(i))
    // Next i
    // add_Ma�linie new_Ma�linie
    // End Function

    // Public Function add_Ma�linie(ByRef ma�linie As clsMa�linie)
    // Set ma�linie.Parent = mMa�linien
    // mMa�linien.Add ma�linie
    // End Function

    // Public Function edit_Ma�linie(ByRef ma�linie As clsMa�linie, ByVal Typ As Integer, knoten() As Integer, ByRef Position As RB_Punkt_2D) As clsMa�linie
    // Dim i As Integer
    // Dim Knoten1 As clsKnoten, Knoten2 As clsKnoten
    // Set Knoten1 = mSys.knoten(knoten(0))
    // Set Knoten2 = mSys.knoten(knoten(1))
    // ma�linie.clear_Knotenliste
    // ma�linie.init Knoten1, Knoten2, Typ, Position
    // For i = 2 To UBound(knoten)
    // ma�linie.add_Knoten mSys.knoten(knoten(i))
    // Next i
    // End Function

    // Public Function delete_Ma�linie_byNumber(ByVal Nummer As Integer)
    // If Nummer > mMa�linien.count Then Exit Function
    // Dim ma�linie As clsMa�linie
    // Set ma�linie = mMa�linien.Item(Nummer - 1)
    // delete_Ma�linie_byHandle ma�linie
    // End Function

    // Public Function delete_Ma�linie_byHandle(ByRef ma�linie As clsMa�linie)
    // If mMa�linien.IndexOf(ma�linie) + 1 > mMa�linien.count Then Exit Function
    // mMa�linien.RemoveAt ma�linie.Nummer - 1
    // End Function

    // Public Property Get ma�linie(ByVal Nummer As Integer) As clsMa�linie: Set ma�linie = mMa�linien.Item(Nummer - 1):  End Property
    // Public Property Get Ma�linienliste() As ListOfObject: Set Ma�linienliste = mMa�linien: End Property

// '----Zeichnen
    // Public Function new_Canvas(ByVal Target As Worksheet, ByVal Left As Single, ByVal Top As Single, ByVal Width As Single, ByVal Height As Single, Optional ByVal name As String) As clsCanvas
    // Dim Canv As New clsCanvas
    // Dim i As Integer
    // For i = 1 To 3
    // If mCanvas(i) Is Nothing Then Exit For
    // Next
    // If i > 3 Then Exit Function
    // Canv.new_Canvas Target, Left, Top, Width, Height, name
    // set_Canvas Canv, i
    // End Function

    // Public Function set_Canvas(ByVal Canvas As clsCanvas, ByVal index As Integer, Optional ByVal name As String)
    // If index > 3 Then
    // MsgBox "es werden nur 3 fenster unterst�tzt"
    // Set Canvas = Nothing
    // End If
    // If Not name = "" Then
    // Canvas.name = name
    // End If
    // Set mCanvas(index) = Canvas
    // End Function

    // Public Property Get Canvas(ByVal Canvasindex As Integer) As clsCanvas: Set Canvas = mCanvas(Canvasindex): End Property
    // Public Property Let Canvas_Flaggs(ByVal Canvasindex As Integer, ByVal Flaggs As Integer): mCanvas(Canvasindex).Drawing_Flaggs = Flaggs: End Property
    // Public Property Get Canvas_Flaggs(ByVal Canvasindex As Integer) As Integer: Canvas_Flaggs = mCanvas(Canvasindex).Drawing_Flaggs: End Property
    // Public Property Let Canvas_Schnittkrafttyp(ByVal Canvasindex As Integer, ByVal Schnittkrafttyp As Integer): mCanvas(Canvasindex).Drawing_Schnittkrafttyp_Flaggs = Schnittkrafttyp: End Property
    // Public Property Get Canvas_Schnittkraftskallierung(ByVal Canvasindex As Integer) As Single: Canvas_Schnittkraftskallierung = mCanvas(Canvasindex).Schnittkraftgr��enfaktor: End Property
    // Public Property Let Canvas_Schnittkraftskallierung(ByVal Canvasindex As Integer, ByVal Wert As Single): mCanvas(Canvasindex).Schnittkraftgr��enfaktor = Wert: End Property

    // Public Property Get Canvas_withEvents(ByVal index As Integer) As clsChartEvents
    // Dim curChart As New clsChartEvents
    // Set curChart.myChartClass = mCanvas(index).ChartObj
    // Set Canvas_withEvents = curChart
    // Canvas_withEvents.init mCanvas(index).ChartObj.Parent.Parent
    // End Property

    // Public Function delete_Canvas(ByVal CanvasNr As Integer)
    // On Error Resume Next
    // mCanvas(CanvasNr).ShapeObj.Delete
    // Set mCanvas(CanvasNr) = Nothing
    // End Function



    // Public Function Draw_system(Optional ByVal Canvas_Nr As Integer = 1, Optional ByVal Lastfall_Nr As Integer = -1)
    // Dim Ma�stab(1 To 2) As Single
    // Dim ma�g_Ma�stab As Single
    // Dim cCanvas As clsCanvas

    // Set cCanvas = mCanvas(Canvas_Nr)
    // cCanvas.Clear

    // Ma�stab(1) = 1000
    // Ma�stab(2) = 1000
    // If Not (Size.Right - Size.Left) = 0 Then Ma�stab(1) = (cCanvas.Width - 2 * RAND) / (Size.Right - Size.Left)
    // If Not (Size.Top - Size.Bottom) = 0 Then Ma�stab(2) = (cCanvas.Height - 2 * RAND) / (Size.Top - Size.Bottom)

    // ma�g_Ma�stab = Ma�stab(1)
    // If Ma�stab(2) < Ma�stab(1) Then ma�g_Ma�stab = Ma�stab(2)

    // cCanvas.Ma�stab = ma�g_Ma�stab
    // cCanvas.update_offset Size.Right + Size.Left, Size.Top + Size.Bottom

    // '---St�be zeichnen
    // Dim curStab As Variant
    // If Not mStabliste.count = 0 Then
    //     For Each curStab In mStabliste.ToArray
    //         curStab.Draw cCanvas
    //     Next
    // End If

    // '---Knoten und Auflager zeichnen
    // Dim curKnoten As Variant
    // If Not mKnotenliste.count = 0 Then
    //     For Each curKnoten In mKnotenliste.ToArray
    //         curKnoten.Draw cCanvas
    //     Next
    // End If


    // '---Lastf�lle Zeichnen
    // Dim cLastfall As clsLastfall
    // If Lastfall_Nr = -1 Then Lastfall_Nr = curLastfall
    // If Lastfall_Nr > 0 Then
    //     Set cLastfall = Me.Lastfall(Lastfall_Nr)
        
    //     '--- Belastung Zeichnen
    //     If cCanvas.Drawing_Flaggs And DRAW_BELASTUNG Then
    //         Dim Knotenlast As Variant
    //         Dim Stablast As Variant
    //         If Not cLastfall.Knotenlasten.count = 0 Then
    //             For Each Knotenlast In cLastfall.Knotenlasten.ToArray
    //                 Knotenlast.Draw cCanvas
    //             Next
    //         End If
    //         If Not cLastfall.Stablasten.count = 0 Then
    //             For Each Stablast In cLastfall.Stablasten.ToArray
    //                 Stablast.Draw cCanvas
    //             Next
    //         End If
    //     End If
        
    //     '--- Auflagerreaktionen Zeichnen
    //     If cCanvas.Drawing_Flaggs And DRAW_AUFLAGERREAKT Then
    //         If cLastfall.Berechnet Then
    //             For Each curKnoten In mSys.Knotenliste.ToArray
    //                 If Not curKnoten.Auflager Is Nothing Then
    //                     Dim cKnoten As clsKnoten
    //                     Set cKnoten = curKnoten
    //                     curKnoten.Auflager.draw_Auflagerreaktionen cCanvas, cKnoten, cLastfall
    //                 End If
    //             Next curKnoten
    //         End If
    //     End If
        
    //     '--- Schnittkr�fte Zeichnen
    //     If cCanvas.Drawing_Flaggs And DRAW_ERGEBNISSE Then
    //         If cLastfall.Berechnet Then
    //         Dim strEinheit(1 To 2) As String
    //             For Each curStab In mSys.Stabliste.ToArray
    //                 curStab.draw_Schnittkraft cCanvas, cLastfall, cCanvas.Drawing_Schnittkrafttyp_Flaggs
    //             Next curStab
    //         draw_Info cCanvas, cCanvas.Drawing_Schnittkrafttyp_Flaggs
    //         End If
    //     End If
    // End If

    //     '--- Bema�ung Zeichnen
    //     If cCanvas.Drawing_Flaggs And DRAW_BEMA�UNG Then
    //         Dim curMa�linie As Variant
    //         If Not mMa�linien.count = 0 Then
    //         For Each curMa�linie In mMa�linien.ToArray
    //             curMa�linie.Draw cCanvas
    //         Next curMa�linie
    //         End If
    //     End If
    // End Function


    // Private Function draw_Info(ByRef Canvas As clsCanvas, ByRef Typ As Integer)

    // Dim strEinheit(1 To 2) As String
    // Dim label As New clsLabel

    // Const Fontgr��e = 10
    // Select Case EINHEIT_BELASTUNG_KRAFT
    // Case Is = Newton
    // strEinheit(1) = "N"
    // Case Is = KiloNewton
    // strEinheit(1) = "kN"
    // Case Is = MegaNewton
    // strEinheit(1) = "MN"
    // End Select

    // Select Case EINHEIT_BELASTUNG_L�NGE
    // Case Is = Meter
    // strEinheit(2) = "m"
    // Case Is = DeziMeter
    // strEinheit(2) = "dm"
    // Case Is = CentiMeter
    // strEinheit(2) = "cm"
    // Case Is = MilliMeter
    // strEinheit(2) = "mm"
    // End Select



    // Select Case Typ
    // Case Is = 1 'Normalkraft
    //     If label.init("Normalkr�fte " & "[" & strEinheit(1) & "]", 5, 5 + Fontgr��e, 0, Fontgr��e) Then
    //     label.Draw Canvas
    //     End If
    // Case Is = 2 'Querkraft
    //     If label.init("Querkr�fte " & "[" & strEinheit(1) & "]", 5, 5 + Fontgr��e, 0, Fontgr��e) Then
    //     label.Draw Canvas
    //     End If
    // Case Is = 3 'Moment
    //     If label.init("Momente " & "[" & strEinheit(1) & strEinheit(2) & "]", 5, 5 + Fontgr��e, 0, Fontgr��e) Then
    //     label.Draw Canvas
    //     End If
    // Case Is = 4 'Verformung
    //     Select Case EINHEIT_VERFORMUNGEN_L�NGE
    //         Case Is = Meter
    //         strEinheit(2) = "m"
    //         Case Is = DeziMeter
    //         strEinheit(2) = "dm"
    //         Case Is = CentiMeter
    //         strEinheit(2) = "cm"
    //         Case Is = MilliMeter
    //         strEinheit(2) = "mm"
    //     End Select
    //     If label.init("Verformungen " & "[" & strEinheit(2) & "]", 5, 5 + Fontgr��e, 0, Fontgr��e) Then
    //     label.Draw Canvas
    //     End If
    // End Select
    // End Function






